import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import ModalBox from '../../../shared/modal';
import Copy from  '../../../shared/copy-to-clipboard';

import classname from 'classname';
import moment from 'moment';
import { Link } from 'react-router';
import { baseUrl } from '../../../../config/route-entry-point';

lessRequire('modules/streams/components/popups/split-sessions.less');

const SplitSessions = (props) => {
	const { intl } = props;
	const className = classname({
		'ReactModal__Content': true,
		'ReactModal__Content--after-open': true,
		'modal-overlay__content': true,
		'streams_split_sessions_modal': true
	});
	return (
		<ModalBox
			body={modalBody(props)}
			isOpen={props.data.shouldShow}
			onClose={props.toggleSplitSessions}
			title={intl('Сплит-сессии')}
			className={className}
		/>
	);
};

const modalBody = (props) => {
	const { data, intl } = props;
	return (
		<div className="streams-table__split-sessions">
			<table className="dashboard-table split-session-table">
				<thead className="dashboard-table__head font-proxima-nova-semibold">
					<tr>
						<th>{intl('Ключ сессии')}</th>
						<th>{intl('Создано')}</th>
						<th>{intl('Остановлено')}</th>
						<th className="right">{intl('Действия')}</th>
					</tr>
				</thead>
				<tbody className="dashboard-table__body">
					{ data.rows && data.rows.map((row, i) => (
						<tr key={i}>
							<td className="session">
								<Copy copyText={row.session_key} intl={intl}>
									<span title={row.session_key}>{row.session_key}</span>
								</Copy>
							</td>
							<td className="datetime">
								<span className="date">
									{moment(row.created_at).format('DD.MM.YYYY')}</span> <span className="time">
									{moment(row.created_at).format('HH:mm')}
								</span>
							</td>
							<td className="datetime">
								{!row.stopped_at && (<span>&mdash;</span>)}
								{row.stopped_at &&
								(<span className="date">{moment(row.stopped_at).format('DD.MM.YYYY')}</span>)
								}
							&nbsp;
								{row.stopped_at &&
								(<span className="time">{moment(row.stopped_at).format('HH:mm')}</span>) || ''
								}
							</td>
							<td className="control">
								<Link to={baseUrl(`statistics/general?${row['statisticQuery']}`)}
									className="statistics" target="_blank"
									title={intl('Статистика')}
								/>
							</td>
						</tr>
					)) }
				</tbody>
			</table>
		</div>
	);
};

SplitSessions.propTypes = {
	data: PropTypes.object,
	toggleSplitSessions: PropTypes.func,
	intl: PropTypes.func
};

modalBody.propTypes = {
	data: PropTypes.object,
	intl: PropTypes.func
};

export default SplitSessions;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/popups/split-sessions.js